import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "@/i18n";

// Icons aligned by index with t.aiFirst.columns
const COLUMN_ICONS = ["integration_instructions", "settings_suggest", "rocket_launch"];

export const AiFirst: React.FC = () => {
  const t = useTranslation();

  const scrollTo = (elementId: string) => {
    document.getElementById(elementId)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div id="ai-first"></div>
      <div className="bg-[#1d2128] py-[72px] md:py-[120px]">
        <div className="max-w-screen-xl m-auto px-[38px] 2xl:px-0">
          <p className="text-[#01C6FB] font-semibold tracking-[0.18em] uppercase text-[13px] md:text-[14px]">
            {t.aiFirst.overline}
          </p>
          <h2 className="mt-3 text-white font-bold text-[28px] leading-[38px] md:text-[44px] md:leading-[56px] max-w-4xl">
            {t.aiFirst.headlinePlain}{" "}
            <span className="text-[#01C6FB]">{t.aiFirst.headlineAccent}</span>
          </h2>
          <p className="mt-5 max-w-3xl text-[16px] leading-[26px] md:text-[18px] md:leading-[30px] text-base-300">
            {t.aiFirst.intro}
          </p>

          <div className="mt-[40px] md:mt-[56px] grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {t.aiFirst.columns.map((column, index) => (
              <motion.div
                key={column.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: index * 0.12 }}
                className="flex flex-col"
              >
                <span className="material-symbols-outlined text-[36px] text-[#01C6FB]">
                  {COLUMN_ICONS[index]}
                </span>
                <h3 className="mt-4 text-[20px] md:text-[22px] font-bold text-white">
                  {column.title}
                </h3>
                <p className="mt-2 text-[15px] leading-[25px] md:text-[16px] md:leading-[27px] text-base-300">
                  {column.text}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5 }}
            className="mt-[48px] md:mt-[64px] rounded-[20px] border border-[#01C6FB]/50 bg-[#01C6FB]/5 p-[28px] md:p-[36px]"
          >
            <p className="text-[17px] leading-[28px] md:text-[20px] md:leading-[32px] text-white font-medium">
              {t.aiFirst.antiHypePlain}{" "}
              <span className="text-[#01C6FB]">{t.aiFirst.antiHypeAccent}</span>
            </p>
          </motion.div>

          <div className="mt-[40px] text-[16px] md:text-[17px] text-base-300">
            {t.aiFirst.ctaLine}{" "}
            <a
              href="#kontakt"
              className="text-[#01C6FB] font-semibold cursor-pointer hover:underline whitespace-nowrap"
              onClick={(event) => {
                event.preventDefault();
                scrollTo("kontakt");
              }}
            >
              {t.aiFirst.ctaLink}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
